import { MultiPolygon, Polygon } from "geojson";
import { z } from "zod";

import { fetchWithError, useParsedQuery } from "@nens/react-query-utils";
import { combineUrlAndParams } from "@nens/shared-utils";

import { AssetKey, getGeom } from "../assets";

export const rasterCountsSchema = z.object({
  results: z.array(
    z.object({
      class: z.number(),
      count: z.number(),
      color: z.string(),
      label: z.string(),
    })
  ),
  excluded: z.number(),
  total: z.number(),
});

export type RasterCounts = z.infer<typeof rasterCountsSchema>;

export function useRasterCounts(
  uuid: string,
  geometry: Polygon | MultiPolygon,
  assetKey?: AssetKey,
  params: Record<string, string | number> = {}
) {
  const geom = getGeom(geometry, assetKey);
  const url = combineUrlAndParams(`/api/v4/rasters/${uuid}/counts/`, { ...params, geom });
  return useParsedQuery<RasterCounts>(
    ["lizard-api-v4", "rastercounts", url],
    () => fetchWithError(url),
    (json: unknown) => rasterCountsSchema.parse(json)
  );
}
